"use strict";
const dataPerType = require('./typesData');

let EventEmitter = require('wolfy87-eventemitter');
let PopupWidget = require('./popupWidget');

class RmWidget extends EventEmitter {
    constructor() {
        super();
        this._registered = false;
        this._onGetCallback = null;
        this.type = undefined;
        this.PopupWidget = PopupWidget;

        //@todo make a better origin check?
        this.id = this._getQueryParameter('widgetCode');
        this.registeredOrigin = this._getQueryParameter('origin');

        window.addEventListener('message', this._handleMessage.bind(this), false);
        this._pageLoaded(() => {
            this._sendMessage('widgetLoadedDone');
            console.log(this.id, {'client created!!!': window});
        });

        // widget popup communication
        this.on('popupMessage', data => {
            this.emit(data[0], data[1]);
        });
    }


    static regFunc(name, func) {
        this.prototype[name] = func;
    }


    send(command, data) {
        if (this.type === 'popup') {
            // send data to the popup widget
            this.rmWidget._sendMessage('popupMessage', [command, data]);
        }
    }


    _pageLoaded(callback) {
        window.addEventListener('load', callback);
        if (document.readyState === 'complete') {
            callback();
        }
    }


    _getQueryParameter(key, defaultValue = null) {
        let queryString = window.location.search;
        let regex = new RegExp('[?|&]' + key + '[=]?([^&]*)[&]?');
        let matches = queryString.match(regex);
        if (matches !== null) {
            return decodeURIComponent(matches[1]);
        }
        return defaultValue;
    }


    _sendMessage(action, data) {
        parent.postMessage({
            id: this.id,
            action: action,
            actionData: data || {}
        }, this.registeredOrigin);
    }


    _handleMessage(event) {
        if (event.origin !== this.registeredOrigin || typeof event.data !== 'object') return;

        // Listen to registerAs when not registered
        if (!this._registered && event.data.action == 'registerAs') {
            this.type = event.data.actionData.type;
            this._registered = true;

            this._afterRegister();
            return;
        }

        console.log(this.id, {'Event from Radiomanager': event});

        // We only handle other messages after we are registered
        if (this._registered && event.data.id == this.id) {
            switch (event.data.action) {
                case('initialize'):
                    this.emit('initialize', event.data.actionData);
                    break;
                case('save'):
                    this.emit('save', () => {
                        this._sendMessage('save-callback', {});
                    });
                    break;
                case('updateWidget'):
                    this.emit('updateWidget', event.data.actionData);
                    break;

                case('droppedOnItem'):
                    this.emit('droppedOnItem', event.data.actionData.itemId, event.data.actionData.customData);
                    break;
                case('getWidgetFromItemCb'):
                    if (this._onGetCallback) {
                        this._onGetCallback(event.data.actionData);
                        this._onGetCallback = null;
                    }
                    break;
                case('selectedItem'):
                    this.emit('selectedItem', event.data.actionData.itemId, event.data.actionData.content);
                    break;
                case('focused'):
                    this.emit('focused');
                    break;
                case('unfocused'):
                    this.emit('unfocused');
                    break;
                case('authorizationKey'):
                    this.emit('authorizationKey', event.data.actionData);
                    break;
                case('screenResize'):
                    this.emit('screenResize', event.data.actionData);
                    break;
                case('popupMessage'):
                    this.emit('popupMessage', event.data.actionData);
                    break;
                case('popupLoaded'):
                    this.emit('popupLoaded');
                    break;
                case('popupClose'):
                    this.emit('popupClose');
                    break;
                case('publishToOthers'):
                    this.emit('publishToOthers', event.data.actionData);
                    break;
                case('fetchRequest'):
                    if (this.__fetchCB) {
                        this.__fetchCB(event.data.actionData);
                    }
                    break;

                case('updatedWidgetUrl'):
                    if (this.__updatedWidgetUrl) {
                        this.__updatedWidgetUrl(event.data.actionData);
                    }
                    break;
            }
        }
    }


    _afterRegister() {
        console.log(this.id, {'client registered as': this.id});

        let data = dataPerType[this.type];
        for (let i = 0; i < data.functions.length; i++) {
            this[data.functions[i]] = require('./functions/' + data.functions[i]).bind(this);
        }

        this.events = data.events;

        this._sendMessage('registered', {});
    }


    updateWidgetUrl(newUrl) {
        this.__updatedWidgetUrl = updatedUrl => {
            if (updatedUrl !== newUrl) return;
            window.location.href = this._makeQueryString(newUrl, {
                widgetCode: this.id,
                origin: this.registeredOrigin,
            });
        };
        this._sendMessage('updateUrl', newUrl);
    }


    _makeQueryString(url, queryParameters = {}) {
        let queryStringPiece = '?';
        if (url.indexOf('?') !== -1) {
            queryStringPiece = '&';
        }

        for (let queryKey in queryParameters) {
            if (queryParameters.hasOwnProperty(queryKey)) {
                let queryVar = queryParameters[queryKey];

                if (typeof queryVar !== 'boolean') {
                    queryVar = encodeURIComponent('' + queryVar);
                } else if (queryVar) {
                    queryVar = '';
                } else {
                    return;
                }

                url += `${queryStringPiece}${encodeURIComponent(queryKey)}=${queryVar}`;

                queryStringPiece = '&';
            }
        }

        return url;
    }
}

window.RmWidget = RmWidget;

module.exports = RmWidget;